// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__pVYiw","back":"style_back__Rf-XK"};